export const CAJERO_ADMIN_ID = 64;

export const checkPaymentsAllowed = authData => Number(authData?.id) === CAJERO_ADMIN_ID;

export const MAX_PAYMENT_AMOUNT = 250000;

export const PAYMENT_STEPS = {
  AMOUNT: 'amount',
  PURCHASE: 'purchase',
  WAITING: 'waiting',
  RESULT: 'result',
};

export const PAYMENT_TIMER_SECONDS = 2 * 60 * 60;

export const PENDING_TIMER_SECONDS = 60 * 60;

export const PAYMENT_RESULT = {
  SUCCESS: 'success',
  ERROR: 'error',
};

export const PAYMENT_NETWORK = 'USDT-TRC20';

export {
  formatElapsed,
  formatTimer,
  getSecondsUntil,
  resolveTimerSeconds,
  sanitizePaymentAmountInput,
} from './helpers';
